export const CORNER_SIZE = 11;

export const KEY_CODE = {
  ESCAPE: 27,
  Z: 90,
  Y: 89
};
